<div
  class="cc-loading-status-indicator"
  *ngrxLet="isActive$ as isActive"
  [@loadingStatusIndicatorAnimation]="isActive ? 'active' : 'inactive'"
  [ngClass]="{ 'cc-loading-status-indicator--active': isActive }"
  [style.transform]="transformStyle$ | async"
  role="bar"
></div>
